import React, { useEffect, useState } from 'react'
import inputErrors from './validation'
import dayjs from "dayjs";
import EditCalendarIcon from '@mui/icons-material/EditCalendar';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import CloseIcon from '@mui/icons-material/Close';
import { useDispatch, useSelector } from 'react-redux';
import {snackbarContext} from '../helpers/Snakbar'
import { clearError, singupdate } from '../../redux/reducers/authSlice';
import { useNavigate } from 'react-router-dom';
import "../authentication/login.css"

const Needdates = () => {
     const setStateSnackbarContext=React.useContext(snackbarContext)
     const [showModal, setShowModal] = useState(false); 
      const {user,error:backendError}=useSelector((state)=>state.auth)
       const navigate=useNavigate()
      const dispatch=useDispatch()
      const [values,setValues]=useState({
             weddingDate:"",
               appEndingDate: "",
             userCode:user?.userCode
            })
              const [errors, setErrors] = useState({});
               const [isSubmitting, setSubmitting] = useState(false);

                     function getCurrentDate() {
                    const today = new Date();
                    const year = today.getFullYear();
                    const month = String(today.getMonth() + 1).padStart(2, '0');
                    const day = String(today.getDate()).padStart(2, '0');
                    return `${year}-${month}-${day}`;
                }

           const handleSubmit=(e)=>{
                  
                  e.preventDefault();
                   const validationErrors=inputErrors(values)
                     if(values.weddingDate<getCurrentDate()){
             validationErrors.weddingDate = `Invalid date. Value must be ${getCurrentDate()} or later.`;
             }
                     setErrors(validationErrors)
                     setSubmitting(true);
                }

                
                                        const handleChange = (event) => {
                              const { name, value } = event.target;
                
                              if (name === "weddingDate") {
                               const selectedDate = dayjs(value);
                              const endingDate = selectedDate.add(20, "day");
                
                                setValues({
                                 ...values,
                                weddingDate: value,
                                appEndingDate: endingDate.format("YYYY-MM-DD") // dd-mm-yyyy
                                });
                              } else {
                                setValues({
                                  ...values,
                                  [name]: value
                                });
                              }
                            };
                

                 useEffect(()=>{
            if(isSubmitting){
               const noErrors = Object.keys(errors).length === 0; 
                   if(noErrors){
                   dateSignupFunc()
                }
            }
             if(backendError){
                setStateSnackbarContext(
                  true,
                  backendError,
                  "error"
                )
                dispatch(clearError())
              }
            },[isSubmitting,errors,backendError])
            
                        const dateSignupFunc=()=>{
              setSubmitting(false)
             dispatch(singupdate({values,navigate,setStateSnackbarContext}))
            }
  return (
    <>
      <div className="payment-overlay">
     <div className="demo-paywall">
        <h2>🎉 Welcome to Aamantran</h2>
 <p className="demo-subtext-1">
       Almost! Just One Last Step
     </p>
       <form className='login-form-container' onSubmit={handleSubmit}>
      <div className={errors.weddingDate?"input-box-error":"input-box"}>
        <input type="date"
       id='weddingDate'
       value={values.weddingDate}
       name='weddingDate'
       placeholder=' '
       className='input-field-login'
       onChange={handleChange}
        />
        <label htmlFor="weddingDate" className="input-label" >Wedding Date </label>
         <span className="label-icon"><EditCalendarIcon/></span>
       </div>
         <div>  {errors.weddingDate &&  ( <small className="error-msg">{errors.weddingDate}</small>) }</div>
       <div className='login-note'>(Imp: Please enter the main wedding day, not the start of other events)</div>
        <div className="input-box ">
       <input type="text"
       id='appEndingDate'
       value={ values.appEndingDate
       ? dayjs(values.appEndingDate).format("DD-MM-YYYY")
       : ""}
       name='appEndingDate'
       placeholder=' '
       className='input-field-login date-disabled'
       readOnly
        />
          <label htmlFor="appEndingDate" className="input-label">Invite Ending Date</label>
            <span className="label-icon"><CalendarMonthIcon/></span>
      </div>
               {/* <div className='login-note'>Note: Invite turns into post-wedding mode after this date <span style={{color:"blue",textDecoration:"underline",marginLeft:"3px"}}  onClick={() => setShowModal(true)}>Know Why?</span></div> */}
       <div className='login-note'>Your invite will remain active until this date <span style={{color:"blue",textDecoration:"underline",marginLeft:"3px"}}  onClick={() => setShowModal(true)}>Know Why?</span></div>
      <button className='continue-button'>   
       <span>Continue to Dashboard</span>
       <div className='forward-icon'><ArrowForwardIcon/></div>  
      </button>
       </form>
     </div>
    </div>
     {showModal && (
        <div className="modal-overlay">
          <div className="modal-container">
            <button className="modal-close" onClick={() => setShowModal(false)}><CloseIcon className='close-icon'/></button>
          <h2 className="modal-title">Invite Validity & Security</h2>
<p className="modal-desc">
Your Aamantran invite is created to match your wedding timeline.
<br /><br />
To keep your invite secure, relevant, and misuse-free, it automatically expires
<strong> 20 days after your main wedding date</strong>.
<br /><br />
<strong>Example:</strong><br />
If your wedding date is <strong>1 Jan 2026</strong>, your invite will stay active
until <strong>21 Jan 2026</strong>.
<br />
</p>

<p className="modal-warning">
<strong>Important:</strong><br />
The expiry date is automatically calculated based on your wedding date
and cannot be changed later.
</p>
          </div>
        </div>
      )}

    </>
  )
}

export default Needdates